import React, { useEffect, useState } from 'react';
import { Box, Paper, Typography, TextField, Button, Alert, CircularProgress } from '@mui/material';
import httpClient, { extractErrorMessage } from '../Services/httpClient';

const formatDateTime = (timestamp) => new Date(timestamp).toLocaleString('pt-BR');

// Painel comprimido pra 1 linha (ajuste pedido pelo usuário).
const PlatformFeePanel = () => {
    const [currentFee, setCurrentFee] = useState(null);
    const [lastChangeAt, setLastChangeAt] = useState(null);
    const [newFee, setNewFee] = useState('');
    const [withdrawalFeePercentage, setWithdrawalFeePercentage] = useState(0);
    const [minimumWithdrawalAmount, setMinimumWithdrawalAmount] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const [isSavingWithdrawal, setIsSavingWithdrawal] = useState(false);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(null);

    const load = async () => {
        setIsLoading(true);
        setError(null);
        try {
            const [feeResponse, historyResponse, withdrawalFeeResponse] = await Promise.all([
                httpClient.get('/backoffice/fee-percentage'),
                httpClient.get('/backoffice/activity-log', {
                    params: { page: 1, pageSize: 1, entityName: 'PlatformFeeConfiguration' }
                }),
                httpClient.get('/backoffice/withdrawal-fee-config')
            ]);
            setCurrentFee(feeResponse.data);
            setNewFee(feeResponse.data);
            setLastChangeAt(historyResponse.data.items[0]?.timestamp ?? null);
            setWithdrawalFeePercentage(withdrawalFeeResponse.data.feePercentage);
            setMinimumWithdrawalAmount(withdrawalFeeResponse.data.minimumAmountLemonCoins);
        } catch (err) {
            setError(extractErrorMessage(err));
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        load();
    }, []);

    const handleSave = async () => {
        setIsSaving(true);
        setError(null);
        setSuccess(null);
        try {
            await httpClient.put('/backoffice/fee-percentage', Number(newFee), {
                headers: { 'Content-Type': 'application/json' }
            });
            setSuccess('Comissão atualizada com sucesso.');
            await load();
        } catch (err) {
            setError(extractErrorMessage(err));
        } finally {
            setIsSaving(false);
        }
    };

    const handleSaveMinimumWithdrawal = async () => {
        setIsSavingWithdrawal(true);
        setError(null);
        setSuccess(null);
        try {
            await httpClient.put('/backoffice/withdrawal-fee-config', {
                feePercentage: withdrawalFeePercentage,
                minimumAmountLemonCoins: Number(minimumWithdrawalAmount)
            });
            setSuccess('Mínimo pra saque atualizado com sucesso.');
            await load();
        } catch (err) {
            setError(extractErrorMessage(err));
        } finally {
            setIsSavingWithdrawal(false);
        }
    };

    return (
        <Paper variant="outlined" sx={{ p: 2, borderRadius: '14px', flex: '1 1 620px' }}>
            {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
            {success && <Alert severity="success" sx={{ mb: 2 }}>{success}</Alert>}

            {isLoading ? (
                <CircularProgress size={24} style={{ color: '#f77513' }} />
            ) : (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap' }}>
                    <Typography variant="subtitle1" sx={{ color: '#f77513', fontWeight: 'bold', whiteSpace: 'nowrap' }}>
                        Comissão
                    </Typography>
                    {currentFee !== null && (
                        <Typography variant="body2" color="text.secondary" sx={{ whiteSpace: 'nowrap' }}>
                            {Number(currentFee).toFixed(2)}% {lastChangeAt && `(${formatDateTime(lastChangeAt)})`}
                        </Typography>
                    )}
                    <TextField
                        label="Comissão (%)"
                        type="number"
                        size="small"
                        sx={{ width: 130 }}
                        value={newFee}
                        onChange={(e) => setNewFee(e.target.value)}
                        inputProps={{ step: '0.01', min: '0', max: '100' }}
                    />
                    <Button
                        variant="contained"
                        disabled={isSaving}
                        style={{ backgroundColor: '#f77513', color: 'white' }}
                        onClick={handleSave}
                    >
                        Salvar
                    </Button>
                    <TextField
                        label="Mínimo p/ saque"
                        type="number"
                        size="small"
                        sx={{ width: 160 }}
                        value={minimumWithdrawalAmount}
                        onChange={(e) => setMinimumWithdrawalAmount(e.target.value)}
                    />
                    <Button
                        variant="contained"
                        disabled={isSavingWithdrawal}
                        style={{ backgroundColor: '#f77513', color: 'white' }}
                        onClick={handleSaveMinimumWithdrawal}
                    >
                        Salvar
                    </Button>
                </Box>
            )}
        </Paper>
    );
};

export default PlatformFeePanel;
